<template>
  <div class="container-fluid my-3 record" style="min-height:50vh">
    <div class="row">
      <div class="col-12 ">
        <div class="d-flex title-box">
          <div class="title" :class="{'active': currentPage==='All'}" @click="goPage('All')">{{ copy.all }}</div>
          <div class="title" :class="{'active': currentPage==='Group'}" @click="goPage('Group')">{{ copy.group }}</div>
        </div>
      </div>
    </div>
    <div class="layout">
      <div>
        <div class="col-12" style="min-height:40vh">
          <div>
            <table class="rwd-table">
            <thead>
              <tr>
                <th colspan="3" class="main-title">{{ copy.currentRanking }}</th>
              </tr>
            </thead>
              <tbody v-if="leaderBoardList">
                <tr>
                  <th>{{ copy.rank }}</th>
                  <th>{{ copy.name }}</th>
                  <th>{{ copy.averageScore }}</th>
                </tr>
                <tr>
                  <td :data-th="copy.rank">
                    {{leaderBoardList.me.no}}
                  </td>
                  <td :data-th="copy.name">
                    {{leaderBoardList.me.name}}
                  </td>
                  <td :data-th="copy.averageScore">
                    {{leaderBoardList.me.score}}
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="rwd-table mt-3">
            <thead>
              <tr>
                <th colspan="3" class="main-title">{{currentPage==='All'?copy.monthlyTop20:copy.classRanking}}</th>
              </tr>
            </thead>
              <tbody v-if="leaderBoardList">
                <tr>
                  <th>{{ copy.rank }}</th>
                  <th>{{ copy.name }}</th>
                  <th>{{ copy.averageScore }}</th>
                </tr>
                <tr v-for="(item, index) in leaderBoardList.top20" :key="index">
                  <td :data-th="copy.rank">
                    {{item.no}}
                  </td>
                  <td :data-th="copy.name">
                    {{item.name}}
                  </td>
                  <td :data-th="copy.averageScore">
                    {{Math.floor(item.score)}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// import Pagination from './Pagination'
import api from '../store/api'
export default {
  name: 'LeaderBoard',
  data () {
    return {
      personalData: null,
      currentPage: 'All',
      recordInfo: null,
      leaderBoardList: null,
      pageIndex: 1,
      pageCount: 0,
    }
  },
  components: {
    // Pagination,
    // DatePicker
  },
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          all: '全站',
          group: '班級',
          currentRanking: '個人當前排名',
          monthlyTop20: '每月前20排名',
          classRanking: '班級排名',
          rank: '排名',
          name: '姓名',
          averageScore: '平均分數'
        },
        en: {
          all: 'All',
          group: 'Class',
          currentRanking: 'Current Personal Ranking',
          monthlyTop20: 'Monthly Top 20',
          classRanking: 'Class Ranking',
          rank: 'Rank',
          name: 'Name',
          averageScore: 'Average Score'
        }
      }
      return copy[this.currentLocale] || copy.tw
    }
  },
  mounted () {
    this.getPersonalData()
    this.getLeaderBoardList(false)
  },
  methods: {
    goPage (el) {
      this.currentPage = el
      this.getPersonalData()
      let isGroup = el==='All'? false: true
      this.getLeaderBoardList(isGroup)
    },
    async getPersonalData () {
      this.personalData = this.$store.state.auth.user
    },

    async getLeaderBoardList ( isGroup ) {
      if (isGroup) {
        const { data } = await api.get(`/speak/ranking/monthly?is_group=${isGroup}`)
        this.leaderBoardList = data.data
      } else {
        const { data } = await api.get(`/speak/ranking/monthly`)
        this.leaderBoardList = data.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/color.scss";
.record {
  text-align: left;
  .layout {
    min-height: 50vh;
  }
}
table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }

  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table tbody th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
.main-title {
  background: rgb(24, 97, 255);
  border: none !important;
}

@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
